import axios from "axios";
import { USER_URL } from "../constant/api";

//  seller data fetch api
export const SellerDataFetchApi = async (id) => {
  try {
    const response = await USER_URL.get(`/accounts/seller-details/${id}/`);
    console.log("seller data",response.data);
    return response.data;
  } catch (error) {
    console.log("Error in seller data", error);
    throw error;
  }
};

// seller banner 

export const SellerBannerFetchApi = async (id) => {
    try {
      const response = await USER_URL.get(`/products/nearest-supplier/${id}/banners/`);
      console.log("seller banner",response.data);
      return response.data;
    } catch (error) {
      console.log("Error in seller data", error);
      throw error;
    }
  };

// seller special offer

export const SellerSpecialOfferFetchApi = async (id) => {
    try {
      const response = await USER_URL.get(`/products/nearest-supplier/${id}/special-offers/`);
      console.log("special offer",response.data);
      return response.data;
    } catch (error) {
      console.log("Error in seller data", error);
      throw error;
    }
  };

  // seller Products 

  export const SellerProductsFetchApi = async (id) => {
    try {
      const response = await USER_URL.get(`/products/all-sellers/2/`);
      // const response = await axios.get("http://93.127.167.39:8020/products/all-sellers/2")
      console.log("seller products",response);
      return response.data.data;
    } catch (error) {
      console.log("Error in seller products data", error);
      throw error;
    }
  };

  // seller brnads 

  export const SellerBrandsFetchApi = async () => {
    try {
      const response = await USER_URL.get(`/products/seller/brand/`);
      console.log("seller brands",response.data);
      return response.data;
    } catch (error) {
      console.log("Error in seller brands data", error);
      throw error;
    }
  };

  export const BrandsFetchApi = async () => {
    try {
      const response = await USER_URL.get(`/products/brand/`);
      console.log("brands",response.data);
      return response.data;
    } catch (error) {
      console.log("Error in seller brands data", error);
      throw error;
    }
  };

